/* Bocni kosik Kousek Severu.
   Registruje <cart-drawer>, ktery hleda product-form.js a quick-add.js.
   Obsah panelu se po kazde zmene prekresli ze sekce ks-cart-drawer. */
(function () {
  if (customElements.get('cart-drawer')) return;

  var SEKCE = 'ks-cart-drawer';

  function vnitrek(html, selector) {
    if (!html) return null;
    var uzel = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return uzel ? uzel.innerHTML : null;
  }

  function jsonPozadavek(url, telo) {
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(telo)
    }).then(function (r) {
      return r.json();
    });
  }

  class KsCartDrawer extends HTMLElement {
    constructor() {
      super();
      this.panel = this.querySelector('.ks-drw__panel');
      this.telo = this.querySelector('#ks-drw-body');
      this.zavri = this.close.bind(this);

      this.addEventListener('click', this.naKlik.bind(this));
      this.addEventListener('keyup', function (e) {
        if (e.code === 'Escape') this.close();
      }.bind(this));

      /* Ikona kosiku v hlavicce otevira panel, ale zustava odkazem na /cart,
         aby fungoval prostredni klik i stranka bez JS.
         Na samotne strance kosiku panel neotevirame - zakaznik uz kosik vidi. */
      this.naStranceKosiku = !!document.querySelector('#main-cart-items, [data-ks-cartpage]');
      if (!this.naStranceKosiku) {
        document.querySelectorAll('[data-ks-cart-link]').forEach(function (odkaz) {
          odkaz.addEventListener('click', function (e) {
            if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
            e.preventDefault();
            this.open();
          }.bind(this));
        }.bind(this));
      }
    }

    /* product-form.js posila tohle id jako parametr sections= */
    getSectionsToRender() {
      return [{ id: SEKCE }];
    }

    setActiveElement(el) {
      this.aktivniPrvek = el;
    }

    renderContents(stav) {
      this.prekresli((stav && stav.sections) || {});
      this.open();
    }

    prekresli(sekce) {
      var html = vnitrek(sekce[SEKCE], '.shopify-section');
      if (html === null) return;
      this.telo.innerHTML = html;
      this.srovnejOdznaky();
    }

    srovnejOdznaky() {
      var koren = this.querySelector('[data-ks-drw-count]');
      if (!koren) return;
      var pocet = parseInt(koren.getAttribute('data-ks-drw-count'), 10);
      if (isNaN(pocet)) return;

      document.querySelectorAll('[data-ks-cart-count]').forEach(function (el) {
        el.textContent = pocet;
        el.toggleAttribute('hidden', pocet < 1);
      });
      document.querySelectorAll('[data-ks-cart-link]').forEach(function (el) {
        el.setAttribute('aria-label', 'Košík (' + pocet + ')');
      });
    }

    open() {
      if (this.classList.contains('is-open')) return;
      this.aktivniPrvek = this.aktivniPrvek || document.activeElement;

      /* Z otevreneho mobilniho menu se chodi na ikonu kosiku - at nezustane pod panelem. */
      var menu = document.querySelector('[data-ks-drawer][open]');
      if (menu) {
        var zavritMenu = menu.querySelector('[data-ks-drawer-close]');
        if (zavritMenu) zavritMenu.click();
      }

      this.classList.add('is-open');
      document.body.classList.add('ks-drw-otevreno');

      var zavrit = this.querySelector('.ks-drw__close');
      if (zavrit) zavrit.focus();
      if (typeof trapFocus === 'function') trapFocus(this.panel);
    }

    close() {
      if (!this.classList.contains('is-open')) return;
      this.classList.remove('is-open');
      document.body.classList.remove('ks-drw-otevreno');
      if (typeof removeTrapFocus === 'function') removeTrapFocus(this.aktivniPrvek);
      this.aktivniPrvek = null;
    }

    naKlik(e) {
      if (e.target.closest('[data-ks-drw-close]')) {
        this.close();
        return;
      }

      var mnozstvi = e.target.closest('[data-ks-drw-qty]');
      if (mnozstvi) {
        this.zmenMnozstvi(mnozstvi);
        return;
      }

      var doplnek = e.target.closest('[data-ks-drw-upsell]');
      if (doplnek) this.pridejDoplnek(doplnek);
    }

    zmenMnozstvi(tlacitko) {
      var polozka = tlacitko.closest('[data-ks-drw-key]');
      if (!polozka || this.pracuje) return;
      /* Klic je stabilni, poradi radku ne - Shopify radi nove pridane nahoru. */
      var klic = polozka.getAttribute('data-ks-drw-key');
      var pocet = parseInt(tlacitko.getAttribute('data-ks-drw-qty'), 10);
      if (!klic || isNaN(pocet) || pocet < 0) return;

      this.zacniPraci();
      jsonPozadavek(window.routes.cart_change_url, {
        id: klic,
        quantity: pocet,
        sections: SEKCE,
        sections_url: window.location.pathname
      })
        .then(function (odpoved) {
          this.prekresli(odpoved.sections || {});
          this.oznamZmenu(odpoved, 'ks-cart-drawer');
        }.bind(this))
        .catch(function (e) {
          console.error(e);
        })
        .finally(this.skonciPraci.bind(this));
    }

    pridejDoplnek(tlacitko) {
      if (this.pracuje || tlacitko.getAttribute('aria-disabled') === 'true') return;
      var varianta = Number(tlacitko.dataset.variantId);
      if (!varianta) return;

      tlacitko.setAttribute('aria-disabled', 'true');
      this.zacniPraci();
      jsonPozadavek(window.routes.cart_add_url, {
        items: [{ id: varianta, quantity: 1 }],
        sections: SEKCE,
        sections_url: window.location.pathname
      })
        .then(function (odpoved) {
          if (odpoved.status) {
            this.ukazChybu(odpoved.description || odpoved.message);
            tlacitko.removeAttribute('aria-disabled');
            return;
          }
          this.prekresli(odpoved.sections || {});
          this.oznamZmenu(odpoved, 'ks-cart-drawer-upsell');
        }.bind(this))
        .catch(function (e) {
          console.error(e);
          this.ukazChybu('Doplněk se nepodařilo přidat. Zkuste to prosím znovu.');
          tlacitko.removeAttribute('aria-disabled');
        }.bind(this))
        .finally(this.skonciPraci.bind(this));
    }

    ukazChybu(zprava) {
      var pole = this.querySelector('[data-cart-upsell-error]');
      if (!pole) return;
      pole.textContent = zprava;
      pole.removeAttribute('hidden');
    }

    oznamZmenu(odpoved, zdroj) {
      if (typeof publish !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
      publish(PUB_SUB_EVENTS.cartUpdate, { source: zdroj, cartData: odpoved });
    }

    zacniPraci() {
      this.pracuje = true;
      this.classList.add('is-busy');
    }

    skonciPraci() {
      this.pracuje = false;
      this.classList.remove('is-busy');
    }
  }

  customElements.define('cart-drawer', KsCartDrawer);
})();
